var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"products-aside"},_vm._l((_vm.products),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":`#${_vm.$parent.getId(item.name)}`}},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }